import { DS_FIELDS_TABLE_REF_SEPARATOR } from '../constants/ds-forms-fields-table-ref-separator.constant';
import { DsFormInstanceTableColumn } from './ds-form-instance-table-column';
import { DsFormInstanceTableRow } from './ds-form-instance-table-row';
import { DsFormInstanceTableValue } from './ds-form-instance-table-value';

export class DsFormInstanceTableValueFront {
  /**
   * lines of table
   */
  rows: DsFormInstanceTableRow[];

  /**
   * DsFormInstanceTableValueFront constructor.
   *
   * @param values DsFormInstanceTableValue cell data
   * @param rowCount number row count
   */
  constructor(values: DsFormInstanceTableValue[], rowCount: number) {
    this.rows = [];
    for (let index = 0; index < rowCount; index++) {
      this.rows.push(new DsFormInstanceTableRow(index));
    }
    values?.forEach((value: DsFormInstanceTableValue) => {
      const references = value?.ref?.split(DS_FIELDS_TABLE_REF_SEPARATOR);
      if (this.rows[+references[0]])
        this.rows[+references[0]].columns[+references[1]] = new DsFormInstanceTableColumn(+references[1], value.value);
    });
  }
}
